import {
  GetResultValidationItemsDocument,
  GetResultValidationItemsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type ResultValidationsItem = NonNullable<
  NonNullable<GetResultValidationItemsQuery['payroll']>['resultValidationsItemsConnection']
>['nodes'][number]

export const useResultValidationsItems = (policyPeriodId: number, employeeIds?: number[]) => {
  const { data, error, refetch, loading } = useQuery(GetResultValidationItemsDocument, {
    variables: {
      policyPeriodId,
      employeeIds,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-first',
  })

  return {
    refetch,
    fetching: loading,
    data: (data?.payroll.resultValidationsItemsConnection.nodes as ResultValidationsItem[]) ?? [],
    error,
  }
}
